export class ImageCaptionGeneratorRequestModel{
  image : File | null=null;
}

export class ImageCaptionGeneratorResponseModel{
  caption!:string;
}
